"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.StyledRightArrowContainer=exports.StyledReceiptContainer=exports.StyledReceipt=void 0;const StyledReceiptContainer=exports.StyledReceiptContainer=_styledComponents.default.div`
    width: 370px;
    display: flex;
    padding: 20px 10px;
    margin: 10px 0px;
    border: 1px solid #dedede;
    cursor: pointer;
    justify-content: space-between;
    box-sizing: border-box;
`,StyledReceipt=exports.StyledReceipt=_styledComponents.default.div`
    width: 330px;
    display: flex;
    justify-content: space-between;
`,StyledRightArrowContainer=exports.StyledRightArrowContainer=_styledComponents.default.div`
`;